/**
 * Real-time multiplayer asteroids game with TypeScript/Bun server and HTML5 Canvas client
 * Asteroids domain - Asteroid entities, spawning, and breakup mechanics
 * asteroids.common.ts - Shared asteroid utilities and configuration exports
 */

import {
  ASTEROID_BREAKUP_COUNTS,
  ASTEROID_MAX_HEALTH,
  ASTEROID_MAX_SPEED,
  ASTEROID_MIN_SPEED,
  ASTEROID_SIZES,
  INITIAL_ASTEROID_COUNT,
} from "@game/config";
import type { AsteroidConfig } from "./asteroids.types";

// Export configuration constants for backward compatibility
export const ASTEROID_CONFIG: AsteroidConfig = {
  MAX_HEALTH: ASTEROID_MAX_HEALTH,
  SIZES: ASTEROID_SIZES,
  BREAKUP_COUNTS: ASTEROID_BREAKUP_COUNTS,
  MIN_SPEED: ASTEROID_MIN_SPEED,
  MAX_SPEED: ASTEROID_MAX_SPEED,
  INITIAL_COUNT: INITIAL_ASTEROID_COUNT,
};
